module.exports = __webpack_public_path__ + "images/mobile/img-empty-file-a0fe7502675de6579baeaa3f78727fda.png";